/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf
'use es6';

import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const PublishButton = ({
  disableSubmit,
  disableSubmitMessage,
  disabledAwaitingUserAction,
  onSubmit,
  renderSubmitButton,
  buttonRef
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disableSubmit,
    placement: "top left",
    title: disableSubmitMessage,
    children: /*#__PURE__*/_jsx("span", {
      children: renderSubmitButton({
        disabled: disableSubmit,
        disableSubmitMessage,
        disabledAwaitingUserAction,
        onClick: onSubmit,
        buttonRef
      })
    })
  });
};
export default PublishButton;